'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CssBaseline from '@mui/material/CssBaseline';
import deepmerge from '@mui/utils/deepmerge';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { createTheme, ThemeProvider as MuiThemeProvider } from './styles';
import { defaultTheme } from './theme';
export default function ThemeProvider({ children, theme, adapterLocale }) {
    const mergedTheme = createTheme(deepmerge(defaultTheme, theme));
    return (_jsx(LocalizationProvider, { adapterLocale: adapterLocale, dateAdapter: AdapterDayjs, children: _jsxs(MuiThemeProvider, { theme: mergedTheme, children: [_jsx(CssBaseline, {}), children] }) }));
}
